export default __webpack_public_path__ + "static/media/roll_blue.e7799d44.svg";